export default __webpack_public_path__ + "fonts/21c7da8db118835db36e0a984d72213a.ttf";